import React, { useState, useEffect } from "react";
import "./Forms.css";
import { Snackbar, Alert as MuiAlert } from "@mui/material"; // Import MuiAlert as Alert
import Select from "react-select";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import axiosInstance from "../axiosinstance";

export default function VisitorForm({ isSidebarExpanded }) {
  const [visitorNameOptions, setVisitorNameOptions] = useState([]);
  const [visitorName, setVisitorName] = useState(null);
  const [visitorDate] = useState(new Date().toISOString().split("T")[0]);
  const [visitorType, setVisitorType] = useState(null);
  const [purposeOfVisit, setPurposeOfVisit] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newVisitorName, setNewVisitorName] = useState("");
  const [visitorContactNumber, setVisitorContactNumber] = useState("");
  const [employeeToMeet, setEmployeeToMeet] = useState(null);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [visitorData, setVisitorData] = useState([]);
  const [formErrors, setFormErrors] = useState({
    visitorName: "",
    visitorContactNumber: "",
    purposeOfVisit: "",
    employeeToMeet: "",
  });
  const [visitorId, setVisitorId] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [entryType, setEntryType] = useState("client");
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [isVisitorModalOpen, setIsVisitorModalOpen] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientOptions, setClientOptions] = useState([]);
  const [newClientName, setNewClientName] = useState("");
  const [selectType, setSelectType] = useState("visitor");
  const [PanNumber, setPanNumber] = useState();
  const [newVisitorContact, setNewVisitorContact] = useState("");
  const [visitorExists, setVisitorExists] = useState(null);
  const [clientContactNumber, setClientContactNumber] = useState("");
  const [servicesTaken, setServcesTaken] = useState("no");
  const navigate = useNavigate();
  // useEffect(() => {
  //   const fetchVisitorData = async () => {
  //     try {
  //       const authKey = localStorage.getItem("authKey");
  //       if (!authKey) {
  //         console.error("No auth key found");
  //         return;
  //       }

  //       const response = await axios.get(`${API_URL}/api/get_visitor`, {
  //         headers: { Authorization: `Bearer ${authKey}` },
  //       });

  //       if (response.status === 200) {
  //         const visitorOptions = response.data.data.map((visitor) => ({
  //           label: visitor.contact_number, // Only show the contact number
  //           name: visitor.visitor_name,

  //           value: visitor.visitor_id,
  //         }));

  //         setVisitorNameOptions(visitorOptions);
  //         setVisitorData(response.data.data);
  //       } else {
  //         console.error("Failed to fetch visitors:", response.statusText);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching visitor names:", error);
  //     }
  //   };

  //   fetchVisitorData();
  // }, []);

  useEffect(() => {
    const fetchVisitorData = async () => {
      try {
        const response = await axiosInstance.get(`/api/get_visitor`);

        if (response.status === 200) {
          const fetchedVisitorData = response.data.data.map((visitor) => ({
            label: `${visitor.visitor_name || "Unknown"} - ${visitor.contact_number
              }`, // ✅ Show name & number
            value: visitor.visitor_id, // Use visitor ID as value
            name: visitor.visitor_name, // Store visitor name for autofill
            contact_number: visitor.contact_number, // Store separately if needed
          }));

          console.log("Fetched Visitor Data:", fetchedVisitorData);

          setVisitorNameOptions(fetchedVisitorData);
          setVisitorData(response.data.data); // Keep the original data if needed elsewhere
        } else {
          console.error("Failed to fetch visitors:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching visitor names:", error);
      }
    };

    fetchVisitorData();
  }, []);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axiosInstance.get(`/api/get_all_employees`);
        if (response.status === 200) {
          const employeeOptions = response.data.data.map((employee) => ({
            label: employee.employee_name,
            value: employee.employee_id,
          }));
          setEmployeeOptions(employeeOptions);
        } else {
          console.error("Failed to fetch employees:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    fetchEmployeeData();
  }, []);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await axiosInstance.get(`/api/get_client_name`);
        const clientOptions = response.data.data.map((client) => ({
          label: `${client.client_name} - ${client.contact_number}`, // ✅ Show name & number
          value: client.client_id, // Keep the ID as value
          contact_number: client.contact_number, // Store number separately if needed
        }));

        setClientOptions(clientOptions);
      } catch (error) {
        console.error("Failed to fetch clients:", error);
      }
    };

    fetchClients();
  }, []);

  const handleClientSelectChange = (selectedOption) => {
    setClientId(selectedOption.value);

    const selectedClient = clientOptions.find(
      (client) => client.value === selectedOption.value
    );

    if (selectedClient) {
      setVisitorContactNumber(selectedClient.contact_number);
      setClientContactNumber(selectedClient.contact_number); // Update client contact as well
      setVisitorType("Existing Client");
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      clientName: "",
    }));
  };

  // const handleVisitorNameChange = (selectedOption) => {
  //   console.log("Selected Visitor:", selectedOption);

  //   if (!selectedOption) {
  //     setVisitorName("");
  //     setVisitorContactNumber("");
  //     setVisitorId(null);
  //     return;
  //   }

  //   if (selectedOption.value === "addNewVisitor") {
  //     setIsVisitorModalOpen(true);
  //     setVisitorId(null);
  //     setVisitorType("NEW");
  //     setVisitorName("");
  //     setVisitorContactNumber("");
  //     return;
  //   }

  //   // Set visitor contact and name based on selection
  //   setVisitorContactNumber(selectedOption.label); // Set contact as label
  //   setVisitorName(selectedOption.name); // Set name from the object
  //   setVisitorId(selectedOption.value); // Store visitor ID
  //   setVisitorType("Existing"); // Set visitor type to Existing
  // };

  // const handleVisitorNameChange = (selectedOption) => {
  //   console.log("Selected Visitor Option:", selectedOption);

  //   if (!selectedOption) {
  //     setVisitorName("");
  //     setVisitorContactNumber("");
  //     setVisitorId(null);

  //     setFormErrors((prevErrors) => ({
  //       ...prevErrors,
  //       visitorContactNumber: "Visitor Contact is required",
  //     }));
  //     console.log("Cleared visitor details.");
  //     return;
  //   }

  //   if (selectedOption.value === "addNewVisitor") {
  //     setIsVisitorModalOpen(true);
  //     setVisitorId(null);
  //     setVisitorType("NEW");
  //     setVisitorName(""); // Allow user to enter a name manually
  //     setVisitorContactNumber("");
  //     console.log("Opening Add New Visitor Modal.");
  //     return;
  //   }

  //   // Find selected visitor from visitorData (where visitor names are stored)
  //   const selectedVisitor = visitorData.find(
  //     (visitor) => visitor.visitor_id === selectedOption.value
  //   );

  //   console.log("Matched Visitor Data:", selectedVisitor);

  //   // Set visitor details from existing visitor selection
  //   setVisitorContactNumber(selectedOption.label); // Set contact from dropdown
  //   setVisitorName(selectedVisitor ? selectedVisitor.visitor_name : "");
  //   setVisitorId(selectedOption.value); // Store visitor ID
  //   setVisitorType("Existing"); // Mark as existing visitor

  //   console.log(
  //     "Updated Visitor Details - Name:",
  //     selectedVisitor ? selectedVisitor.visitor_name : "",
  //     "Contact:",
  //     selectedOption.label
  //   );
  // };

  const handleVisitorNameChange = (selectedOption) => {
    console.log("Selected Visitor Option:", selectedOption);

    if (!selectedOption) {
      setVisitorName("");
      setVisitorContactNumber("");
      setVisitorId(null);

      setFormErrors((prevErrors) => ({
        ...prevErrors,
        visitorContactNumber: "Visitor Contact is required",
      }));
      console.log("Cleared visitor details.");
      return;
    }

    if (selectedOption.value === "addNewVisitor") {
      setIsVisitorModalOpen(true);
      setVisitorId(null);
      setVisitorType("NEW");
      setVisitorName(""); // Allow user to enter a name manually
      setVisitorContactNumber("");
      console.log("Opening Add New Visitor Modal.");
      return;
    }

    // Find selected visitor from visitorData
    const selectedVisitor = visitorData.find(
      (visitor) => visitor.visitor_id === selectedOption.value
    );

    console.log("Matched Visitor Data:", selectedVisitor);

    // Set visitor details
    setVisitorContactNumber(selectedOption.label);
    setVisitorName(selectedVisitor ? selectedVisitor.visitor_name : "");
    setVisitorId(selectedOption.value);
    setVisitorType("Existing");

    // ✅ Remove error when a valid visitor is selected
    setFormErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors.visitorContactNumber; // Completely remove the error key
      return newErrors;
    });

    console.log(
      "Updated Visitor Details - Name:",
      selectedVisitor ? selectedVisitor.visitor_name : "",
      "Contact:",
      selectedOption.label
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();

    let errors = {};
    if (entryType === "client" && !clientId) {
      errors.clientName = "Client Name is required";
    }

    if (!purposeOfVisit) errors.purposeOfVisit = "Purpose of Visit is required";
    if (!visitorContactNumber)
      errors.visitorContactNumber = "Visitor Contact Number is required";
    if (!employeeToMeet) errors.employeeToMeet = "Employee to Meet is required";

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      // const payload = {
      //   visitor_date: visitorDate,
      //   select_type: entryType,
      //   purpose_of_visit: purposeOfVisit,
      //   contact_number: visitorContactNumber,
      //   employee_to_meet: employeeToMeet,
      //   client_id: entryType === "client" && clientId ? clientId : null,
      //   visitor_id: entryType === "visitor" && visitorId ? visitorId : null,
      //   visit_type: visitorType || "existing",
      //   visitor_name:
      //     entryType === "visitor"
      //       ? visitorName || "" // ✅ Always use manually entered name
      //       : undefined,
      // };

      const payload = {
        visitor_date: visitorDate,
        select_type: entryType,
        service_avail: servicesTaken,
        purpose_of_visit: purposeOfVisit,
        contact_number: visitorContactNumber,
        employee_to_meet: employeeToMeet,
        client_id: entryType === "client" && clientId ? clientId : null,
        visitor_id:
          entryType === "visitor" && visitorType !== "NEW" ? visitorId : null, // ✅ Only send visitor_id if NOT a new visitor
        visit_type: visitorType || "existing",
        visitor_name:
          entryType === "visitor"
            ? visitorName || "" // ✅ Always use manually entered name
            : undefined,
      };

      console.log(payload, "hell");

      const response = await axiosInstance.post(`/api/create_visitor`, payload);

      if (response.status === 200) {
        setSnackbarSeverity("success");
        setSnackbarMessage("Visitor added successfully!");
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/visitor");
        }, 3000);
      } else {
        console.error("Failed to save visitor:", response.statusText);
        alert("Failed to save visitor information. Please try again.");
      }
    } catch (error) {
      console.error("Error saving visitor information:", error);
      if (error.response) {
        console.error("Response error:", error.response.data); // Log the server response
      }
      alert("An error occurred while saving visitor information.");
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCancel = () => {
    window.history.back();
  };
  const handleEmployeeSelectChange = (selectedOption) => {
    const employeeId = selectedOption ? selectedOption.value : null;
    setEmployeeToMeet(employeeId);

    if (selectedOption) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        employeeToMeet: "",
      }));
    }
  };

  // const handleAddNewVisitor = (e) => {
  //   e.preventDefault();

  //   const trimmedContact = newVisitorContact.trim();
  //   console.log("Adding new visitor with contact:", trimmedContact);

  //   if (!trimmedContact) {
  //     alert("Please enter the visitor's contact number.");
  //     return;
  //   }

  //   // Check for duplicate contact
  //   const isDuplicate = visitorNameOptions.some(
  //     (visitor) => visitor.value === trimmedContact
  //   );
  //   console.log("Is Duplicate Contact:", isDuplicate);

  //   if (isDuplicate) {
  //     alert("Visitor contact number already exists.");
  //     return;
  //   }

  //   // Create new visitor object
  //   const newVisitor = { label: trimmedContact, value: trimmedContact };
  //   console.log("New Visitor Object:", newVisitor);

  //   // Update state with new visitor
  //   const updatedVisitorNameOptions = [...visitorNameOptions, newVisitor];
  //   setVisitorNameOptions(updatedVisitorNameOptions);
  //   localStorage.setItem(
  //     "visitorNameOptions",
  //     JSON.stringify(updatedVisitorNameOptions)
  //   );

  //   // Set visitor fields
  //   setVisitorName(newVisitor); // Update select with new visitor
  //   setVisitorContactNumber(trimmedContact); // Set contact number
  //   setVisitorType("NEW");

  //   console.log("VisitorName state:", newVisitor);
  //   console.log("VisitorContactNumber state:", trimmedContact);
  //   setIsVisitorModalOpen(false); // Close the modal
  // };

  const handleAddNewVisitor = (e) => {
    e.preventDefault();

    const trimmedContact = newVisitorContact.trim();
    console.log("Adding new visitor with contact:", trimmedContact);

    // ✅ Validate if contact number is valid
    if (
      !trimmedContact ||
      trimmedContact.length < 10 ||
      isNaN(trimmedContact)
    ) {
      alert("Please enter a valid 10-digit contact number.");
      return;
    }

    // Check for duplicate contact
    const isDuplicate = visitorNameOptions.some(
      (visitor) => visitor.value === trimmedContact
    );
    console.log("Is Duplicate Contact:", isDuplicate);

    if (isDuplicate) {
      alert("Visitor contact number already exists.");
      return;
    }

    // Create new visitor object
    const newVisitor = { label: trimmedContact, value: trimmedContact };
    console.log("New Visitor Object:", newVisitor);

    // Update state with new visitor
    const updatedVisitorNameOptions = [...visitorNameOptions, newVisitor];
    setVisitorNameOptions(updatedVisitorNameOptions);
    localStorage.setItem(
      "visitorNameOptions",
      JSON.stringify(updatedVisitorNameOptions)
    );

    // ✅ Auto-fill visitor contact & allow name entry
    setVisitorContactNumber(trimmedContact);
    setVisitorName(""); // Ensure input field is editable
    setVisitorId(trimmedContact); // Reset visitor ID to allow manual name input
    setVisitorType("NEW");

    console.log("VisitorName state (should be empty for manual input):", "");
    console.log("VisitorContactNumber state:", trimmedContact);

    setIsVisitorModalOpen(false); // Close the modal
  };

  useEffect(() => {
    const storedVisitorNames = localStorage.getItem("visitorNameOptions");

    if (storedVisitorNames) {
      setVisitorNameOptions(JSON.parse(storedVisitorNames)); // Update state with the stored data
    }
  }, []); // This will run only once when the component mounts

  const handleRadioChange = (e) => {
    setEntryType(e.target.value);
  };

  const handleVisitorNumberChange = async (e) => {
    const contactNumber = e.target.value;
    setNewVisitorContact(contactNumber);

    if (contactNumber.length === 10) {
      try {
        const response = await axiosInstance.post(
          `/api/check_visitor_contact_number`,
          { contact_number: contactNumber }
        );
        const data = await response.json();

        if (response.ok) {
          setVisitorExists(false); // Number is available
        } else {
          setVisitorExists(true); // Number exists
        }
      } catch (error) {
        console.error("Error checking visitor:", error);
        setVisitorExists(null);
      }
    } else {
      setVisitorExists(null); // Reset if not a valid number
    }
  };

  const handleRadioChanges = (e) => {
    setServcesTaken(e.target.value);
  };

  return (
    <div
      className={`table-container visitor-form-page ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content form-main-body visitor-form-content">
        <div className="visitor-page-heading">
          <h1 className="form-title">New Visitor</h1>
          <p className="visitor-page-subtitle">
            Record visitor details, purpose of visit and employee interaction.
          </p>
        </div>
        <div className="visitor-form-card">
        <div className="form-body visitor-form-body">
          <form className="form-box visitor-form-box">
            <div className="form-body-container visitor-form-sections">
            <section className="visitor-form-section">
              <div className="visitor-section-header">
                <div>
                  <h2 className="visitor-section-title">
                    Visitor Classification
                  </h2>
                  <p className="visitor-section-description">
                    Choose the entry type and identify the visitor or client.
                  </p>
                </div>
              </div>
            {/* Radio Buttons for Client and Visitor */}
            <div className="form-group visitor-form-span-2">
              <label className="form-label">Select Type</label>
              <div className="form-inputs">
                <div className="visitor-radio-group">
                <label className="radio-label visitor-radio-label">
                  <input
                    type="radio"
                    name="entryType"
                    value="client"
                    checked={entryType === "client"}
                    onChange={handleRadioChange}
                    autoFocus
                  />
                  Client
                </label>
                <label className="radio-label visitor-radio-label">
                  <input
                    type="radio"
                    name="entryType"
                    value="visitor"
                    checked={entryType === "visitor"}
                    onChange={handleRadioChange}
                  />
                  Visitor
                </label>
                </div>
              </div>
            </div>

            {entryType === "client" && (
              <div className="form-group">
                <label className="form-label">
                  Client Name <span className="required">*</span>
                </label>

                {entryType === "client" && (
                  <Select
                    className="select-field-visitor"
                    options={clientOptions}
                    value={
                      clientOptions.find((opt) => opt.value === clientId) ||
                      null
                    }
                    onChange={handleClientSelectChange}
                    placeholder="Select Client Name"
                    /** ✅ CRITICAL FIX FOR Z-INDEX */
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 999999,
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 999999,
                        position: "absolute",
                      }),
                      control: (base) => ({
                        ...base,
                        zIndex: 9999,
                        position: "relative",
                      }),
                      container: (base) => ({
                        ...base,
                        zIndex: 9999,
                        position: "relative",
                      }),
                    }}
                  />
                )}
                {formErrors.clientName && (
                  <div className="error-message">{formErrors.clientName}</div>
                )}
              </div>
            )}

            {entryType === "visitor" && (
              <div className="form-group">
                <label className="form-label">
                  Visitor Contact<span className="required">*</span>
                </label>
                <div className="form-inputs">
                  <Select
                    className="select-field-visitorname"
                    value={
                      visitorNameOptions.find(
                        (option) => option.value === visitorId
                      ) || null
                    }
                    onChange={handleVisitorNameChange}
                    options={[
                      ...visitorNameOptions,
                      {
                        label: "➕ Add New Visitor",
                        value: "addNewVisitor",
                        isSpecial: true,
                      },
                    ]}
                    placeholder="Select Visitor Contact"
                    menuPortalTarget={document.body} // ✅ ADD THIS
                    getOptionLabel={(e) =>
                      e.isSpecial ? (
                        <strong style={{ color: "blue" }}>{e.label}</strong>
                      ) : (
                        e.label
                      )
                    }
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 999999 // ✅ ADD THIS
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 999999, // ✅ INCREASE THIS
                        position: "absolute"
                      }),
                      control: (base) => ({
                        ...base,
                        zIndex: 9999,
                        position: "relative"
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        backgroundColor: state.data.isSpecial
                          ? "#f0f8ff"
                          : state.isFocused
                            ? "#e0e0e0"
                            : "white",
                        color: state.data.isSpecial ? "blue" : "black",
                        fontWeight: state.data.isSpecial ? "bold" : "normal",
                      }),
                    }}
                  />

                  {formErrors.visitorContactNumber && (
                    <p className="error-message">
                      {formErrors.visitorContactNumber}
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="form-group">
              <label className="form-label">
                Visitor Type <span className="required">*</span>
              </label>
              <div className="form-inputs">
                <input
                  type="text"
                  className="input-field"
                  value={visitorType || ""}
                  readOnly
                />
              </div>
            </div>
            </section>

            {isVisitorModalOpen && (
              <div className="visitor-add-modal-root" style={{ zIndex: 999999 }}>
                <div
                  className="visitor-add-modal-shell"
                  style={{ zIndex: 1000000 }}
                >
                  <div className="visitor-add-modal-header">
                    <div>
                      <h2 className="visitor-add-modal-title">Add New Visitor</h2>
                      <p className="visitor-add-modal-subtitle">
                        Add a visitor contact number to continue this visit entry.
                      </p>
                    </div>
                  </div>

                  <div className="visitor-add-modal-body">
                    <div className="visitor-add-modal-field">
                      <label className="visitor-add-modal-label">
                        Visitor Contact Number <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        className="visitor-add-modal-input"
                        value={newVisitorContact}
                        onChange={handleVisitorNumberChange}
                        placeholder="Enter Visitor Number"
                      />

                      {visitorExists !== null && (
                        <p
                          className={`visitor-add-modal-status ${
                            visitorExists
                              ? "visitor-add-modal-status-error"
                              : "visitor-add-modal-status-success"
                          }`}
                        >
                          {visitorExists
                            ? "Visitor already exists with this contact number."
                            : "Contact number is available."}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="visitor-add-modal-footer">
                    <button
                      type="button"
                      className="visitor-add-modal-btn visitor-add-modal-btn-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        setNewVisitorContact("");
                        setIsVisitorModalOpen(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="visitor-add-modal-btn visitor-add-modal-btn-primary"
                      onClick={handleAddNewVisitor}
                      disabled={visitorExists}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
            <section className="visitor-form-section">
              <div className="visitor-section-header">
                <div>
                  <h2 className="visitor-section-title">Visit Information</h2>
                  <p className="visitor-section-description">
                    Capture the visit date, contact details and purpose.
                  </p>
                </div>
              </div>
            <div className="form-group">
              <label className="form-label">
                Visitor Date <span className="required">*</span>
              </label>
              <div className="form-inputs">
                <input
                  type="date"
                  className="input-field"
                  value={visitorDate}
                  readOnly
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                {entryType === "client" ? "Client Contact" : "Visitor Name"}
                <span className="required">*</span>
              </label>
              <div className="form-inputs">
                {entryType === "client" ? (
                  <input
                    type="text"
                    className="input-field"
                    value={clientContactNumber || ""}
                    placeholder="Client Contact Number"
                    readOnly
                  />
                ) : (
                  <input
                    type="text"
                    className="input-field"
                    value={visitorName || ""}
                    placeholder="Visitor Name"
                    onChange={(e) => setVisitorName(e.target.value)}
                    disabled={visitorType !== "NEW" && visitorId !== null} // ✅ Disable only for existing visitors
                  />
                )}
              </div>
            </div>
            <div className="form-group visitor-form-span-2">
              <label className="form-label">
                Purpose of Visit <span className="required">*</span>
              </label>
              <div className="form-inputs">
                <input
                  type="text"
                  className="input-field"
                  value={purposeOfVisit}
                  onChange={(e) => {
                    setPurposeOfVisit(e.target.value);
                    setFormErrors({ ...formErrors, purposeOfVisit: "" });
                  }}
                  placeholder="Enter Purpose of Visit"
                />
                {formErrors.purposeOfVisit && (
                  <p className="error-message">{formErrors.purposeOfVisit}</p>
                )}
              </div>
            </div>
            </section>

            <section className="visitor-form-section visitor-form-section-last">
              <div className="visitor-section-header">
                <div>
                  <h2 className="visitor-section-title">
                    Service &amp; Meeting Details
                  </h2>
                  <p className="visitor-section-description">
                    Track service availability and the employee involved.
                  </p>
                </div>
              </div>
            <div className="form-group">
              <label className="form-label">
                Services Taken <span className="required">*</span>
              </label>
              <div className="form-inputs">
                <div className="visitor-radio-group">
                {/* Yes Radio Button */}
                <label className="radio-label visitor-radio-label">
                  <input
                    type="radio"
                    name="servicesTaken"
                    value="yes"
                    checked={servicesTaken === "yes"}
                    onChange={handleRadioChanges}
                  />
                  Yes
                </label>

                {/* No Radio Button */}
                <label className="radio-label visitor-radio-label">
                  <input
                    type="radio"
                    name="servicesTaken"
                    value="no"
                    checked={servicesTaken === "no"}
                    onChange={handleRadioChanges}
                  />
                  No
                </label>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">
                Employee to Meet <span className="required">*</span>
              </label>
              <div className="form-inputs">
                <Select
                  className="select-field-visitorname"
                  value={
                    employeeOptions.find(
                      (option) => option.value === employeeToMeet
                    ) || null
                  } // Ensure it matches the selected option
                  onChange={handleEmployeeSelectChange} // Use the function to handle change
                  options={employeeOptions}
                  placeholder="Select Employee to Meet"
                  menuPortalTarget={document.body}
                  menuPlacement="auto"
                  maxMenuHeight={220}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 999999,
                    }),
                    menu: (base) => ({
                      ...base,
                      marginTop: 0,
                      borderTop: "none",
                      borderTopLeftRadius: 0,
                      borderTopRightRadius: 0,
                      width: "100%",
                      minWidth: 0,
                      zIndex: 999999,
                    }),
                    control: (base) => ({
                      ...base,
                      marginBottom: 0,
                      minWidth: 0,
                      zIndex: 9999,
                      position: "relative",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      minWidth: 0,
                    }),
                    singleValue: (base) => ({
                      ...base,
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }),
                    option: (base) => ({
                      ...base,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }),
                  }}
                />
                {formErrors.employeeToMeet && (
                  <div className="error-message">
                    {formErrors.employeeToMeet}
                  </div>
                )}
              </div>
            </div>
            </section>
            </div>
          </form>
        </div>
      <div className="form-footer">
        <div className="button-group">
          <button
            type="button"
            className="btn btn-cancel"
            onClick={handleCancel}
          >
            CANCEL
          </button>
          <button type="submit" className="btn btn-save" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>
      </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ transform: "translateY(50px)", marginLeft: "20px" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity="success">
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
